import styled from 'styled-components';

export const Form = styled.form`
  background-color: var(--white);
  padding: 20px;
  color: #000;
`;

export const Submit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const AccordeonContainer = styled.div`
  margin-top: 20px;

  a{
    text-decoration: none;
  }
`;